
const downloadFile = async (fileUrl, fileName) => {
    try {
      console.log("download pdf name", fileName)
        const response = await fetch(fileUrl)
        // console.log('res', response)
        //How to throw error?
        // throw Error()

        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
  
        const a = document.createElement('a')
        a.href = url;
        a.download = fileName
        document.body.appendChild(a)
        a.click()
  
        window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Error downloading the PDF:', error)
      // throw error
      //Need to throw error, if we want to do validations.
    }
} 


export default downloadFile